import { environment as proEnvironment } from "./environment.production";

export const environment = {
  ...proEnvironment,
  NAME: "DEV",
  ANALYTICS_ENABLED: false,
  WEB_BASE_URL: "https://webapp-dev.aiball.io",
  API_BASE_URL: "https://api-dev.aiball.io",
};
